import CommonBubble from './CommonBubblePresenter';

export default CommonBubble;
